/* Camion de l'infobulle des segments et de sa vue agrandie (dessin : resultsPageChrome/menuHelpTruck.js).
   Compartiments de l'étape encadrés à la couleur de l'opération. */
.truck-load-truck svg { display: block; width: 100%; height: auto; overflow: hidden; }
.truck-load-truck .cst-name { fill: #64748b; font-size: 34px; font-weight: 800; text-anchor: middle; }
/* Infobulle : camion limité en hauteur et centré, noms un peu plus grands pour rester lisibles. */
.truck-load-preview svg { width: auto; height: 5.25rem; max-width: 100%; margin-inline: auto; }
.truck-load-preview .cst-name { font-size: 38px; }
.truck-load-truck .cst-out { stroke: transparent; stroke-width: 2; }
.truck-load-truck .cst-out[data-hot="true"] { stroke: #fff; stroke-width: 8; }
.truck-load-truck[data-kind="load"] .cst-out[data-hot="true"] { stroke: #5a79be; stroke-width: 9; }
.truck-load-truck[data-kind="deliv"] .cst-out[data-hot="true"] { stroke: #c38b24; stroke-width: 9; }
.truck-load-truck .cst-flow { fill: none; stroke-linecap: round; stroke-dasharray: 0.1 6; animation: truck-load-flow 0.32s linear infinite; }
@keyframes truck-load-flow { to { stroke-dashoffset: -6.1; } }

@media (prefers-reduced-motion: reduce) {
  .truck-load-truck .cst-flow { animation: none; }
}
